import BaseStore from "./BaseStore";
import * as qs from "query-string";
import extract_user from '../functions/extract'

class UserStore extends BaseStore {
  authenticateGoogle() {
    const API_URL = process.env.REACT_APP_API;
    window.location.replace(API_URL + "/users/auth/google_oauth2");
  }
  sign_in(auth, onError) {
    return this.axios.post("/sign_in", auth).then(r => {
      this.initLoginUser(r.data.uri).then(r => {
        //this timer is for register session data when using LDAP
        setTimeout(function (){
          window.location.href='/';
        }, 500);

      });
    }, onError);
  }

  totp_qr() {
    return this.axios.patch("/users/gen_totp");
  }

  toggle_tfa(code, tfa) {
    if (tfa === true) return this.disable_code(code);
    return this.enable_code(code);
  }

  valid_code(code) {
    return this.axios.put("/users/valid_totp_code", { code });
  }
  disable_code(code) {
    return this.axios.put("/users/disable_totp_code", { code });
  }
  enable_code(code) {
    return this.axios.put("/users/enable_totp_code", { code });
  }

  signout() {
    return new Promise((resolve, reject) => {
      this.axios.post("/sign_out");
      localStorage.clear();
      this.isAuthenticated = false;
      this.setGlobalHeaders();
      this.unsubscribe_notification();
      resolve(this.isAuthenticated);
    });
  }

  get(id) {
    return this.axios.get("/users/" + id);
  }

  info() {
    return {
      name: this.getLocal("name"),
      short_name: this.getLocal("short_name"),
      email: this.getLocal("email"),
      id: this.getLocal("id"),
      can_create: this.getLocal("can_create"),
      title: this.getLocal("title"),
      job_title: this.getLocal("job_title"),
      institution: this.getLocal("institution"),
      department: this.getLocal("department"),
      temp_profile: this.getLocal("temp_profile"),
      can_edit_date: this.getLocal("can_edit_date"),
      can_grant: this.getLocal("can_grant"),
      can_trace: this.getLocal("can_trace"),
      badges_inbox: this.getLocal("badges_inbox"),
      badges_pending: this.getLocal("badges_pending"),
      badges_review: this.getLocal("badges_review"),
      user: this.getLocal("user"),
      needs_approval: this.getLocal("needs_approval"),
      is_supervisor: this.getLocal("is_supervisor"),
      verified: this.getLocal("verified"),
      notify: this.getLocal("notify"),
      read_notifications: this.getLocal("read_notifications"),
    };
  }

  initLoginUser(search) {

    return new Promise((resolve, reject) => {
      const parsed = qs.parse(search);
      if (parsed.error !== undefined) return reject(parsed.error);
      if (parsed.token !== undefined && parsed !== undefined) {
        this.saveLocal("token", parsed.token);
        this.saveLocal("email", parsed.email);
        this.saveLocal("tfa", parsed.tfa);
        this.saveLocal("name", parsed.name);
        this.saveLocal("id", parsed.id);
        this.saveLocal("short_name", parsed.short_name);
        this.saveLocal("can_create", parsed.can_create);
        this.saveLocal("title", parsed.title);
        this.saveLocal("job_title", parsed.job_title);
        this.saveLocal("institution", parsed.institution);
        this.saveLocal("department", parsed.department);
        this.saveLocal("temp_profile", parsed.temp_profile);
        this.saveLocal("can_edit_date", parsed.can_edit_date);
        this.saveLocal("can_grant", parsed.can_grant);
        this.saveLocal("can_trace", parsed.can_trace);
        this.saveLocal("badges_inbox", parsed['badges[inbox]']);
        this.saveLocal("badges_pending", parsed['badges[pending]']);
        this.saveLocal("badges_review", parsed['badges[review]']);
        this.saveLocal("user", extract_user(parsed.email));
        this.saveLocal("needs_approval", parsed.needs_approval);
        this.saveLocal("is_supervisor", parsed.is_supervisor);
        this.saveLocal("verified", false);
        this.saveLocal("notify", parsed.notify);
        this.saveLocal("read_notifications", parsed.read_notifications);
        this.setGlobalHeaders();
          //get browser
          const browser = this.get_browser()

          //get ip and update data to session
          this.get_ip().then( ip => {
            this.update_session(ip.origin, browser, parsed.id)
          });

      }
      this.isAuthenticated = parsed.email !== undefined;
      this.saveLocal("auth", this.isAuthenticated);
      resolve(this.isAuthenticated);
    });

  }

  unsubscribe_notification() {
    if (navigator.serviceWorker !== undefined)
      navigator.serviceWorker.ready.then(function(reg) {
        reg.pushManager.getSubscription().then(function(subscription) {
          subscription
            .unsubscribe()
            .then(function(successful) {
              // You've successfully unsubscribed
            })
            .catch(function(e) {
              // Unsubscription failed
            });
        });
      });
  }

  subscribe_notification() {
    if (navigator.serviceWorker === undefined) return;
    const axios = this.axios;
    //setup the push notification with a vapid key
    navigator.serviceWorker.ready.then(function(registration) {
      return registration.pushManager
        .getSubscription()
        .then(async function(subscription) {
          if (subscription) {
            return subscription;
          }
          const response = await axios("/vapid_public_key");
          const vapidPublicKey = await response.data;
          const convertedVapidKey = new Uint8Array(vapidPublicKey);
          return registration.pushManager
            .subscribe({
              userVisibleOnly: true,
              applicationServerKey: convertedVapidKey
            })
            .then(subscription => {
              axios.patch("/users/subscribe_notification", {
                subscription: subscription,
                message: "You clicked a button!"
              });
              return subscription;
            });
        });
    });
  }

  search(str, withGroups = false, type) {
    let params = { q: str, withGroups: withGroups }
    if (type !== null){
      params = {...params, permission: type}
    }

    return this.axios.get("/users", { params });
  }

  list_sessions(user_id){
    return this.axios.get("/users/"+user_id+"/list_devices");
  }

  kill_session(user_id, id_device){
    return this.axios.put("/users/"+user_id+"/remove_device",{device_id: id_device});
  }

  update_session(ip, browser, user){
    return this.axios.patch("/users/"+user+"/set_session_data", {
      ip: ip,
      device: browser
    });
  }

  get_browser (){
    let ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {name:'IE',version:(tem[1] || '')};
    }
    if(M[1]=== 'Chrome'){
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem != null) return {name:tem[1].replace('OPR', 'Opera'),version:tem[2]};
    }
    M = M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem = ua.match(/version\/(\d+)/i))!= null)
        M.splice(1, 1, tem[1]);
      return M[0] + ' v.' + M[1]
 }

 get_ip(){
    return this.axios.get('https://httpbin.org/ip')
    .then(response => {
      return response.data
    })
 }

 update_profile(user, title, job_title, notifyStatus){
   return this.axios.patch("/users/"+user+"/set_profile",{
     title: title,
     job_title: job_title,
     notify: notifyStatus
   });
 }

 update_temp_profile(user, temp_id, title, job_title){
   return this.axios.patch("/users/"+user+"/temp_profile",{
     temp_id: temp_id,
     title: title,
     job_title: job_title
   })
 }

 update_local_profile(title,job_title){
   this.saveLocal("title", title)
   this.saveLocal("job_title", job_title)
 }

 send_email_verification(user){
   return this.axios.patch("/users/"+user+"/send_verification_email");
 }

 send_code_to_verify(user, code){
   return this.axios.patch("/users/"+user+"/verify_email_code",{
     unlock_token: code
   })
 }

 setReadNotifications(user){
    return this.axios.patch(`/users/${user}/read_notifications`);
 }

}

export default new UserStore();



// WEBPACK FOOTER //
// ./src/stores/UserStore.js